module.exports = __webpack_public_path__ + "static/img/xw.a83dd11b.png";